import { fromJS } from 'immutable'
import {
  SHOW_MANUAL_PROJECT_INFORMATION,
  CLOSE_MANUAL_PROJECT_INFORMATION,
  SET_TYPE_MANUAL_PROJECT_INFORMATION,
} from './../../constants'

const init = fromJS({
  type: 2,
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SHOW_MANUAL_PROJECT_INFORMATION:
      return state
        .set('isFetching', true)
        .set('isOpen', true)
    case CLOSE_MANUAL_PROJECT_INFORMATION:
      return state
        .set('isFetching', false)
        .set('isOpen', false)
    case SET_TYPE_MANUAL_PROJECT_INFORMATION:
      return state
        .set('type', action.payload)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-manual.js